import clsx from 'clsx';
import React from 'react';

import SubmenuNav from '../index';
import { SettingsSubmenuNavItemProps } from './NavItem';

type SettingsSubmenuNavProps = SettingsSubmenuNavItemProps & {
  avatarUrl: string;
  isProSubscriber: boolean;
  isScrollStyle?: boolean;
};

const SettingsSubmenuNav = ({
  className,
  avatarUrl,
  isProSubscriber,
  isScrollStyle,
  ...rest
}: SettingsSubmenuNavProps) => (
  <SubmenuNav
    name="Settings"
    image={
      <img
        className={clsx('h-32 w-32 overflow-hidden rounded-full sm:h-40 sm:w-40', {
          'border-2 border-solid border-[#C6A26C]': isProSubscriber,
        })}
        src={avatarUrl}
        alt=""
      />
    }
    className={clsx(className, 'relative block border-none bg-transparent p-0 leading-[0]')}
    submenuClasses={clsx(
      'absolute -right-10 top-[43px] sm:top-full sm:right-0 w-[197px] sm:w-[235px] bg-grayscale-charcoal px-32 py-24 text-white',
      {
        '-right-16 top-[62px]': isScrollStyle,
      }
    )}
    isScrollStyle={isScrollStyle}
    openOnHover={false}
    {...rest}
  />
);

export default SettingsSubmenuNav;
